// Globale jQuery-Instanz aus vendor.js (inkl. Plugins wie rebox), damit application.js keine eigene Kopie bündelt
module.exports = window.jQuery
